module.exports = __webpack_public_path__ + "media/team_photos/Andre-Torkler-photo-dfb1bc3c.webp";